module.exports = __webpack_public_path__ + "img/search.1092d873.svg";